import type { MessageRosterEntry, MessageThread } from "../../../../packages/shared/src/messages.ts";

export const FIELD_INBOX_FILTERS = ["all", "critical", "action", "boards", "messages"] as const;
export type FieldInboxFilter = (typeof FIELD_INBOX_FILTERS)[number];

export const FIELD_INBOX_FILTER_LABELS: Readonly<Record<FieldInboxFilter, string>> = {
  all: "All",
  critical: "Critical",
  action: "Action",
  boards: "Boards",
  messages: "Messages",
};

export const MESSAGES_EMPTY_TITLE = "No messages yet";
export const MESSAGES_EMPTY_BODY =
  "Direct and crew threads land here. Site announcements stay on Boards. Life safety stays in Critical.";
export const MESSAGES_NOTE = "Direct and crew. Not announcements.";
export const BOARDS_NOTE = "Announce only. No reply.";
export const RETENTION_COPY = "Kept with account records";

export interface MessageCrewSite {
  readonly siteId: string;
  readonly siteName: string;
}
export function messageRoleLabel(role: string): string {
  const normalized = role.trim().replaceAll("_", " ");
  return normalized === ""
    ? "Officer"
    : `${normalized.slice(0, 1).toUpperCase()}${normalized.slice(1)}`;
}

export function messageInitials(name: string): string {
  const words = name.trim().split(/[^A-Za-z0-9]+/).filter(Boolean).slice(0, 2);
  if (words.length === 0) return "MS";
  if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
  return `${words[0]![0]}${words[1]![0]}`.toUpperCase();
}

export function messageComposerPlaceholder(kind: "direct" | "crew", name: string): string {
  return kind === "crew" ? "Message for this shift" : `Message ${name}`;
}

export function messageReachLabel(kind: MessageRosterEntry["reachKind"]): string {
  if (kind === "dispatch") return "Dispatch";
  if (kind === "same_site") return "Same site";
  if (kind === "shift_roster") return "Shift roster";
  return "Site roster";
}

export function formatMessageWhen(iso: string, nowMs: number = Date.now()): string {
  const parsed = new Date(iso);
  if (!Number.isFinite(parsed.getTime())) return "";
  const now = new Date(nowMs);
  const clock = parsed.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  if (
    parsed.getFullYear() === now.getFullYear() &&
    parsed.getMonth() === now.getMonth() &&
    parsed.getDate() === now.getDate()
  ) {
    return clock;
  }
  const day = parsed.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  return `${day} · ${clock}`;
}

export function messageThreadSecondary(thread: MessageThread): string {
  const kind = thread.kind === "direct" ? "Direct" : `Crew · ${thread.memberCount} members`;
  if (thread.lastPostBody === null || thread.lastPostAuthorDisplayName === null) return kind;
  return `${kind} · ${thread.lastPostAuthorDisplayName}: ${thread.lastPostBody}`;
}
